import { useEffect, useRef } from 'react';
import { useOrbitFormSection } from '../hooks/useOrbitFormSection';
import { OrbitCallInfoProps } from '../sectionProps';
import { initialValues, validationSchema } from './formData';

export const useOrbitCallInfo = ({
    onChangeFormik,
    seededCallId,
}: OrbitCallInfoProps) => {
    const { formik } = useOrbitFormSection({
        initialValues,
        validationSchema,
        onChangeFormik,
    });

    const callIdSeeded = useRef(false);

    useEffect(() => {
        if (callIdSeeded.current) return;
        if (!seededCallId || seededCallId === formik.values.callId) return;
        callIdSeeded.current = true;
        formik.setFieldValue('callId', seededCallId);
    }, [seededCallId, formik.values.callId]);

    return { formik };
};
